<template>
    <div class="page-content" id="planning-form">
        <Titlebar :incrustation="'fa-calendar'" :backPath="'/parameters/planning'">
            <h1 v-html="pageTitle"></h1>
        </Titlebar>
        <LoadingMini ref="loading"></LoadingMini>
        <div class="row justify-content-center" v-if="planning">
            <div class="col-4 col-xl-4">
                <UiCard>
                    <form class="form p-0">
                        <div class="form-row row">
                            <label class="col-4">{{ $t('planning.form.label') }}</label>
                            <div class="col-8">

                                <input type="text" v-model="planning.label" name="label" class="form-input w-100"
                                v-validate
                                data-vv-rules="required" :data-vv-as="$t('planning.form.label')"
                                @change="modification()"/>
                                <span class="form-input-error" v-show="showErrors['label'] && errors.has('label')"
                                @click="hideError('label')">{{ errors.first('label') }}</span>
                                <small class="form-text text-muted">{{$t('planning.form.labelHelp')}}</small>
                            </div>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('planning.form.profile') }}</label>
                            <div class="col-8">
                                <multiselect
                                    id="planningProfiles"
                                    class="from-top"
                                    v-model="planningProfiles"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :taggable="false"
                                    placeholder=""
                                    :options="profiles"
                                    label="label"
                                    name="profiles"
                                    track-by="profileId"
                                    @blur="modification"
                                    @tag="modification"
                                    @select="modification"
                                    @remove="modification"
                                    :loading="profilesLoading"
                                >
                                    <template slot="option" slot-scope="{ option }">
                                        <span class="d-flex align-items-center">
                                            <ProfileIcon v-if="option.meta.icon" :icon="option.meta.icon" class="mr-2" />
                                            <span class="text-truncate">{{ option.label }}</span>
                                        </span>
                                    </template>
                                    <template slot="tag" slot-scope="{ option }">
                                        <span class="d-flex align-items-center">
                                            <ProfileIcon v-if="option.meta.icon" :icon="option.meta.icon" class="mr-2" />
                                            <span class="text-truncate">{{ option.label }}</span>
                                        </span>
                                    </template>
                                </multiselect>
                                <span class="form-input-error" v-show="showErrors['profiles'] && errors.has('label')"
                                    @click="hideError('label')">{{ errors.first('label') }}</span>
                                <small class="form-text text-muted">{{$t('planning.form.profileHelp')}}</small>
                            </div>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('planning.form.group') }}</label>
                            <div class="col-8">
                                <multiselect
                                    id="planningGroups"
                                    class="from-top"
                                    v-model="planningGroups"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :taggable="false"
                                    placeholder=""
                                    :options="groups"
                                    label="label"
                                    name="groups"
                                    track-by="id"
                                    @blur="modification"
                                    @tag="modification"
                                    @select="modification"
                                    @remove="modification"
                                    :loading="groupsLoading"
                                >
                                    <template slot="option" slot-scope="{ option }">
                                        <span>{{ option.label }}</span>
                                    </template>
                                    <template slot="tag" slot-scope="{ option }">
                                        <span>{{ option.label }}</span>
                                    </template>
                                </multiselect>
                                <span class="form-input-error" v-show="showErrors['groups'] && errors.has('label')"
                                    @click="hideError('label')">{{ errors.first('label') }}</span>
                                <small class="form-text text-muted">{{$t('planning.form.groupHelp')}}</small>
                            </div>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('planning.form.dati') }}</label>
                            <div class="col-8">
                                <multiselect
                                    id="planningDatis"
                                    class="from-top"
                                    v-model="planningDatis"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :taggable="false"
                                    placeholder=""
                                    :options="datis"
                                    label="label"
                                    name="datis"
                                    track-by="id"
                                    @blur="modification"
                                    @tag="modification"
                                    @select="modification"
                                    @remove="modification"
                                    :loading="datisLoading"
                                >
                                    <template slot="option" slot-scope="{ option }">
                                        <span>{{ option.label }}</span>
                                    </template>
                                    <template slot="tag" slot-scope="{ option }">
                                        <span class="tag-content">
                                            {{ option.label || option.name }}
                                        </span>
                                        <template v-if="option.from">
                                            <div class="tooltip bottom" style="width: 140px;bottom: calc(100% + 5px); right: calc(50% - 14px);">
                                                {{ option.fromObject.name || option.fromObject.label }}
                                            </div>
                                        </template>
                                    </template>
                                </multiselect>
                                <span class="form-input-error" v-show="showErrors['datis'] && errors.has('label')"
                                    @click="hideError('label')">{{ errors.first('label') }}</span>
                                <small class="form-text text-muted">{{$t('planning.form.datiHelp')}}</small>
                            </div>
                        </div>
                        <div class="form-row row">
                            <label class="col-4">{{ $t('planning.form.active') }}</label>
                            <div class="col-8 col-xl-6">
                                <UiSwitch 
                                    v-model="planning.active" 
                                    :trueValue="1"
                                    :falseValue="0" 
                                    @input="() => hasModifications = true" 
                                />
                            </div>
                            <small class="col-8 offset-4 form-text text-muted">{{$t('planning.form.activeHelp')}}</small>
                            </div>
                            <div class="form-row row planning-description">
                                <p>{{$t('planning.form.notificationHelp')}}</p>
                            </div>
                            <div class="form-row row">
                            <NotificationPhonePreview :title="notificationPreview.title" :description="notificationPreview.content" display="small" />
                        </div>
                    </form>
                </UiCard>
            </div>

            <div class="col-8 col-xl-8">
                <UiCard class="full-height">
                    <Calendar 
                        ref="calendar" 
                        :config="config" 
                        @select="timeSelect" 
                        @eventDrop="eventDrop" 
                        @eventResize="eventResize"
                        class="full-height"
                    />
                </UiCard>
            </div>
        </div>
        <Toolbar>
            <Btn :class="['primary pull-right',{disabled:!formIsValidable}]" @click.native.prevent="validForm()"
                 v-can="'beepiz-edit-profiles'">
                {{ $t('global.save') }}
            </Btn>
            <Btn :class="'pull-right'" v-can="'profiles.profiles.edit'">
                <router-link to="/parameters/planning" tag="span">{{ $t('global.cancel') }}</router-link>
            </Btn>
        </Toolbar>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import API from '@/services/API.js';
    import Auth from '@/services/auth.js';
    import Multiselect from '@/components/ui/Multiselect'
    import _concat from 'lodash/concat'
    import _filter from 'lodash/filter'
    import _map from 'lodash/map'
    import _findIndex from 'lodash/findIndex'

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import ProfileIcon from "@/components/profiles/ProfileIcon";
    import UiCard from "@/components/ui/Card";
    import UiSwitch from "@/components/ui/Switch";

    import FormUtils from '@/services/form.js';

    import Utils from "@/services/utils.js";

    import Calendar from '@/components/ui/fullcalendar/Calendar'

    import moment from 'moment'
    import NotificationPhonePreview from "../../components/misc/NotificationPhonePreview";
    import LoadingMini from '@/components/ui/LoadingMini';
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'ProfilesForm',
        components: {
            NotificationPhonePreview,
            Titlebar,
            Toolbar,
            Btn,
            Multiselect,
            Calendar,
            ProfileIcon,
            UiCard,
            UiSwitch,
            LoadingMini
        },
        computed: {
            formIsValidable: function () {
                if (this.hasModifications == true) {
                    return true;
                }
                return false;
            },
            pageTitle: function () {
                if (this.$route.params.id && this.$route.meta.specialAction == null) {
                    if (this.planning) {
                        return this.planning.label;
                    }
                    return '';
                } else {
                    return Utils.t('planning.titles.new');
                }
            },

            isEditRoute(){
                if(this.$route.name == 'PlanningShow' && !this.$route.meta.specialAction){
                    return true
                }
                return false
            },
            notificationPreview() {
                return {
                    title: 'planning.form.notificationPreviewTitle',
                    content: `planning.form.notificationPreviewContent.${Utils.getThemeName()}`
                }
            }
        },
        data: () => ({
            hasModifications: false,
            showErrors: {
                label: false
            },
            planning: null,
            planningProfiles: [],
            planningGroups: [],
            planningDatis: [],
            profilesLoading: false,
            groupsLoading: false,
            datisLoading: false,
            profiles: [],
            groups: [],
            datis: [],
            events: [],
            config: {
                allDaySlot: false,
                columnFormat: 'dddd',
                defaultView: 'agendaWeek',
                displayEventEnd: false,
                events: [],
                eventRender: function(event, element, view){
                  if (null === event.end && null !== event.start) {
                    event.end = moment(event.start).endOf('day')
                  } else if (null === event.start && null !== event.end) {
                    event.start = moment(event.end).startOf('day')
                  }
                  element.find('.fc-content').html('<div class="spe-content"><div class="spe-text">'+event.start.format('HH:mm')+' - '+event.end.format('HH:mm')+'</div><div class="delete-btn" onclick="window.planningForm.deleteSlot(\''+event._id+'\')"><i class="fa fa-trash"></i></div></div>')
                },
                eventOverlap: false,
                eventConstraint:{
                    start: '00:00', // a start time (start of the day in this example)
                    end: '24:00', // an end time (end of the day in this example)
                },
                firstDay: 1,
                fixedWeekCount: false,
                header: false,
                height: "auto",
                locale: window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_LOCALE'),
                slotLabelFormat: 'H:mm',
                navLinks: false,
                slotEventOverlap: false,
                timeFormat: 'H:mm',
                selectable: true,
                selectHelper: false,
                editable: true,
                views: {
                    agendaWeek: {
                        columnFormat: 'dddd',
                        timeFormat: 'h:mm',
                        labelFormat: 'h:mm',
                        slotDuration: '00:15:00',
                        slotLabelInterval: '01:00'
                    }
                },
                weekNumbers: false,
                weekNumbersWithinDays: false,
            }
        }),
        methods: {
            setEmptySelectorToCorrectDateTime(obj) {
              if (null === obj.end && null !== obj.start) {
                obj.end = moment(obj.start).endOf('day')
              } else if (null === obj.start && null !== obj.end) {
                obj.start = moment(obj.end).startOf('day')
              }
              return obj
            },
            isPremium(datiOffer){
                return datiOffer == 35 || datiOffer == 43 || datiOffer == 58
            },
            refetchEvents(){
                this.$refs.calendar.callMethod('removeEvents')
                this.$refs.calendar.callMethod('refetchEvents')
            },
            timeSelect(view, start, end){
                //préparation de la boucle
                //système d'heures (start.hour end.hour)
                let event = {title: 'Test'}
                const startOfWeek = moment().startOf('week').hour(0)
                let firstDay = start.day()
                let lastDay = end.day()

                if(firstDay === 0) firstDay = 7
                if(lastDay === 0) lastDay = 7

                if(end.hour() === 0 && end.minute() === 0) {
                  lastDay -= 1
                  end.set({'hour': 23, 'minute': 59, 'second': 59})
                }

                const dayCount = 1 + lastDay - firstDay;

                for (let i = 0; i < dayCount; i++) {
                  const selectedDay = firstDay + i
                  event = {
                    title: 'Test',
                    start  : startOfWeek.clone().add(selectedDay - 1, 'day').hour(start.hour()).minute(start.minute()).second(0).format('YYYY-MM-DD HH:mm:ss'),
                    end    : startOfWeek.clone().add(selectedDay - 1, 'day').hour(end.hour()).minute(end.minute()).second(0).format('YYYY-MM-DD HH:mm:ss')
                  }

                  if (dayCount > 1) {
                    const startFromSeveralDays = startOfWeek.clone().add(selectedDay - 1, 'day').hour(0).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss')
                    const endFromSeveralDays = startOfWeek.clone().add(selectedDay - 1, 'day').hour(23).minute(59).second(59).format('YYYY-MM-DD HH:mm:ss')

                    if (selectedDay === firstDay) {
                      event.end = endFromSeveralDays
                    } else if (selectedDay === lastDay) {
                      event.start = startFromSeveralDays
                    } else {
                      event = {start : startFromSeveralDays, end : endFromSeveralDays}
                    }
                  }

                  this.config.events.push(event)
                  this.$refs.calendar.callMethod('renderEvent', event, true)
                }
                this.$refs.calendar.callMethod('refetchEvents')
                this.modification()
            },
            eventDrop(){
                this.modification()
            },
            eventResize(){
                this.modification()
            },
            selectProfile(item){
            },
            validForm: function () {
                this.$refs.loading.show();
                this.hideAllErrors;
                this.$validator.validateAll().then(() => {
                    const vm = this
                    let timeslots = []

                    this.$refs.calendar.callMethod('clientEvents').forEach(item => {
                        item = vm.setEmptySelectorToCorrectDateTime(item)
                        timeslots.push({
                            type: null,
                            start_date: null,
                            start_time: item.start.format('HH:mm:ss'),
                            end_date: null,
                            end_time: item.end.format('HH:mm:ss'),
                            days: [item.start.day()]
                        })
                    })

                    let planningToSave = {
                        label: this.planning.label,
                        universe: 'beepiz',
                        scheduler_type: 'working_notification',
                        timeSlots: timeslots,
                        active: this.planning.active,
                        datisToAttach: this.planningDatis.filter(item => { return item.from === null }).map(item => { return item.id }),
                        groupsToAttach: this.planningGroups.map(item => { return item.id }),
                        profilesToAttach: this.planningProfiles.map(item => { return item.profileId })
                    }

                    if(this.isEditRoute){
                        axios.put(API.endpoints.planning.addOrEdit + '/' + this.planning.id, planningToSave)
                            .then(response => {
                                if (response.status == 201) {
                                    window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                                    window.V._router.replace('/parameters/planning/')
                                }
                            })
                            .catch(error => {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                                this.$refs.loading.hide();
                            });
                    }
                    else {
                        axios.post(API.endpoints.planning.addOrEdit, planningToSave)
                            .then(response => {
                                if (response.status == 201) {
                                    window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                                    window.V._router.replace('/parameters/planning/')
                                }
                                if (response.status == 200) {
                                    this.loadData();
                                }
                            })
                            .catch(error => {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                                this.$refs.loading.hide();
                            });
                    }
                }).catch(() => {
                    this.showAllErrors();
                    this.$refs.loading.hide();
                });
            },
            showAllErrors: function () {
                for (var showError in this.showErrors) {
                    this.showErrors[showError] = true;
                }
            },
            hideAllErrors: function () {
                for (var showError in this.showErrors) {
                    this.showErrors[showError] = false;
                }
            },
            hideError: function (key) {
                this.showErrors[key] = false;
            },
            removeItem() {
                Vue.nextTick(() => {
                    this.modification();
                })
            },
            mergeDatis(firstLoad) {
                let datis = []

                Vue.nextTick(() => {
                    this.planningProfiles.forEach(profile => {
                        datis = _concat(datis, _map(_filter(this.datis, dati => {
                            if(dati.profile) {
                                return dati.profile.id == profile.profileId && this.isPremium(dati.offer)
                            }
                        }),dati => {
                            return {
                                id: dati.id,
                                label: dati.label,
                                from: 'profile',
                                fromObject: profile,
                                className: 'readonly',
                                readonly: true
                            }
                        }))
                    })

                    this.planningGroups.forEach(group => {
                        datis = _concat(datis, _map(_filter(this.datis ,dati => {
                            if(dati.groupId) {
                                return dati.groupId == group.id && this.isPremium(dati.offer)
                            }
                        }),dati => {
                            return {
                                id: dati.id,
                                label: dati.label,
                                from: 'group',
                                fromObject: group,
                                className: 'readonly',
                                readonly: true
                            }
                        }))
                    })

                    datis = _concat(datis, _filter(this.planningDatis, dati => {
                        return dati.from === null
                    }))

                    datis = _filter(datis, (dati, index, self) =>
                        index === _findIndex(self, (t) => (
                            t.id === dati.id
                        ))
                    )

                    Vue.set(this,'planningDatis',datis)
                })

            },
            onFilter: function (value) {
                this.filterStr = Utils.sanitize(value);
            },
            loadData: function () {
                this.$refs.loading.show();
                this.hasModifications = false;
                var planningId = this.$route.params.id;
                axios.get(API.route(API.endpoints.planning.show, {planningId: planningId}))
                    .then(response => {
                        this.planning = response.data

                        const now = moment()
                        const startOfWeek = moment().startOf('week').hour(0)

                        //let events = []
                        this.planning.timeslots.forEach(item => {
                            if(item.end_time == '00:00:00' || item.end_time == null) {
                              item.end_time = '23:59:59'
                            }
                            const startTemp = item.start_time.split(':')
                            const endTemp = item.end_time.split(':')
                            item.days.forEach(day => {
                                if(day == 0){
                                    day = 7
                                }
                                this.config.events.push({
                                    title: 'Test',
                                    start  : startOfWeek.clone().add(day -1,'days').hour(startTemp[0]).minute(startTemp[1]).second(startTemp[2]).format('YYYY-MM-DD HH:mm:ss'),
                                    end    : startOfWeek.clone().add(day -1,'days').hour(endTemp[0]).minute(endTemp[1]).second(endTemp[2]).format('YYYY-MM-DD HH:mm:ss')
                                })
                            })

                        })

                        let datis = []

                        let profiles = []
                        this.planning.profiles.forEach(item => {
                                profiles.push({
                                    profileId: item.id,
                                    label: item.name,
                                    nbDatis: item.datis.length,
                                    meta: {
                                        icon: item.icon
                                    }
                                })
                            item.datis.forEach(itemDati => {
                                datis.push({
                                    id: itemDati.id,
                                    label: itemDati.name,
                                    from: 'profile',
                                    fromObject: item,
                                    className: 'readonly',
                                    readonly: true
                                })
                            })
                        })
                            this.planningProfiles = profiles
                        let groups = []
                        this.planning.groups.forEach(item => {
                                groups.push({
                                    id: item.id,
                                    label: item.name,
                                    nbDatis: item.datis.length,
                                })
                            item.datis.forEach(itemDati => {
                                datis.push({
                                    id: itemDati.id,
                                    label: itemDati.name,
                                    from: 'group',
                                    fromObject: item,
                                    className: 'readonly',
                                    readonly: true
                                })
                            })
                        })
                            this.planningGroups = groups

                        this.planning.datis.forEach(item => {
                            datis.push({
                                id: item.id,
                                label: item.name,
                                from: null
                            })
                        })
                        Vue.set(this,'planningDatis',datis)

                        this.$refs.loading.hide();
                    })
            },
            loadProfiles: function () {
                this.profilesLoading = true;
                axios.get(API.endpoints.profiles.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.profiles = response.data.data;
                        for (var i = 0; i < this.profiles.length; i++) {
                            this.profiles[i].label = this.profiles[i].meta.name
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.profilesLoading = false)
            },
            loadGroups: function () {
                this.groupsLoading = true;
                axios.get(API.endpoints.groups.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.groups = response.data.data;
                        for (var i = 0; i < this.groups.length; i++) {
                            this.groups[i].label = this.groups[i].name
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.groupsLoading = false)
            },
            loadDevices: function () {
                this.datisLoading = true;
                axios.get(API.endpoints.datis.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.datis = response.data.data;
                        for (var i = 0; i < this.datis.length; i++) {
                            this.datis[i].label = this.datis[i].name
                        }

                        this.datis = this.datis.filter(dati => {
                            return this.isPremium(dati.offer)
                        }).map(dati => {
                            return {
                                id: dati.id,
                                label: dati.name,
                                offer: dati.offer,
                                groupId: dati.groupId,
                                profile: dati.profile,
                                from: null
                            }
                        })
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.datisLoading = false)
            },
            modification: function (section,key) {
                this.mergeDatis(false)
                this.hasModifications = true
            },
            deleteSlot(eventId){
                this.$refs.calendar.callMethod('removeEvents', eventId)
                this.modification()
            }
        },
        mounted() {
            if (!useDvFlagAccess("beepiz-planning-reminder-can:create")) {
              this.$router.push({ name: 'AccessDenied', params: { slug: "planning_no_role"} })
            }
            moment.locale("fr");
            window.Vfc.$refs.loading.hide();
            window.planningForm = this
            if(this.isEditRoute) {
                this.loadData();
            } else {
                if(this.$route.meta.specialAction){
                    this.loadData()
                }
                else{
                    this.planning = {
                        label: '',
                        profiles: [],
                        groups: [],
                        datis: [],
                        active: 1
                    }
                }
            }

            this.loadProfiles();
            this.loadGroups();
            this.loadDevices();
        },
        destroyed() {
            window.planningForm = null
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.loadData();
        },
    }
</script>

<style scoped>

</style>
